import React, { forwardRef, useImperativeHandle, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  Typography,
  Button,
  Tabs,
  message,
  Flex,
} from "antd";

import {
  EditOutlined,
  BankOutlined,
} from "@ant-design/icons";

import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const [activeBank, setActiveBank] = useState(0);

  /* ----------------------  打开 Modal 时默认添加 bank-1 ---------------------- */
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      form.resetFields();
      setVisible(true);

      // 清空后默认新增 bank-1
      setTimeout(() => {
        form.setFieldsValue({ bankList: [{}] });
        setActiveBank(0);
      }, 0);
    },
  }));

  function useLazySelect(apiUrl, key, mapper, enableCache = true) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async (params = {}) => {
      if (options.length && enableCache) return;

      setLoading(true);
      const res =
        params && Object.keys(params).length > 0
          ? await http.get(apiUrl, { params })
          : await http.get(apiUrl);

      setOptions(mapper(res?.data || []));
      setLoading(false);
    };

    const resetOptions = () => setOptions([]);
    return { options, loading, load, resetOptions };
  }

  const trustSelect = useLazySelect(api.getTrustDictList, "trust", (data) =>
    data.map((d) => ({
      label: d.trustNameTitle,
      value: d.trustId,
      glChartNameId: d.glChartNameId,
    })),
  );

  // const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
  //   data.map((s) => ({ label: s, value: s })),
  // );
  const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
  Object.entries(data || {}).map(([key, label]) => ({
    label,   
    value: key, 
  })),
);
  const glSelect = useLazySelect(
    api.getAcctDictList,
    "glacct",
    (data) =>
      data.map((d) => ({
        label: d.glAcctTitle,
        // value: d.glChartId,
         value:d.glAcct
      })),
    false,
  );
  const ownerSelect = useLazySelect(api.getOwnerDictList, "owner", (data) =>
    data.map((d) => ({
      label: d.titleName,
      value: d.ownerId,
    })),
  );

  const glChartNameOptions = [
    { label: "Z64", value: 1 },
    { label: "GEN", value: 2 },
    { label: "STORE", value: 3 },
  ];

  const serviceNameOptions = [
    { label: "Z64", value: 1 },
    { label: "GEN", value: 2 },
  ];

  const onGLChartChange = async (glChartNameId) => {
    glSelect.resetOptions();
    form.setFieldsValue({ glAcct: undefined });
    await glSelect.load({ glChartNameId });
  };

  const onTrustChange = async (trustId) => {
    const trust = trustSelect.options.find((item) => item.value === trustId);
    if (!trust) return;

    glSelect.resetOptions();
    form.setFieldsValue({ glAcct: undefined });

    await glSelect.load({ glChartNameId: Number(trust.glChartNameId) });
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await http.post(api.getTrustAdd, values);
      if (res?.code === "1") {
        message.success("Successfully.");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else message.error(res?.msg);
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            CREATE ENTITY
          </Typography.Title>
        </Flex>
      }
      width="35%"
      open={visible}
      maskClosable={false}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      footer={
           <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="close"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Close
        </Button>

        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
 
        <Flex align="flex-start" justify="flex-start" gap={32}>
          <div className="model_top" style={{ width: "100%" }}>
               <div className="model_content">
       <Form
        form={form}
        layout="horizontal"
        className="compact-form"    
        onFinish={onFinish}
        labelCol={{ style: { width: "200px" } }}
      >
            <Flex
              align="flex-start"
              justify="space-between"
              gap={32}
              style={{ width: "100%" }}
            >
              {/* =================  左栏：Trust Detail ================= */}
              <div style={{ flex: 1, minWidth: 300 }}>
                {/* <div className="modal-section-title">
                  <BankOutlined /> Trust Detail
                </div> */}

                <Form.Item
                  name="trust"
                  label="Entity Code"
                  rules={[{ required: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                  name="trustName"
                  label="Entity Name"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  name="ownerId"
                  label="Owner"
                  rules={[{ required: true }]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    placeholder="Select Owner"
                    allowClear
                    options={ownerSelect.options}
                    loading={ownerSelect.loading}
                    onFocus={() => ownerSelect.load()}
                  />
                </Form.Item>

                <Form.Item
                  name="glChartNameId"
                  label="GL Chart Name"
                  rules={[{ required: true }]}
                >
                  <Select
                    options={glChartNameOptions}
                    onChange={onGLChartChange}
                  />
                </Form.Item>

                <Form.Item
                  name="serviceNameId"
                  label="Service Name"
                  rules={[{ required: true }]}
                >
                  <Select options={serviceNameOptions} />
                </Form.Item>

                <Form.Item name="street" label="Street">
                  <Input />
                </Form.Item>
                <Form.Item name="city" label="City">
                  <Input />
                </Form.Item>
                <Form.Item name="county" label="County">
                  <Input />
                </Form.Item>

                <Form.Item name="state" label="State" >
                  <Select
                    placeholder="Select State"
                    loading={stateSelect.loading}
                    options={stateSelect.options}
                    onDropdownVisibleChange={(open) =>
                      open && stateSelect.load()
                    }
                  />
                </Form.Item>

               <Form.Item
               name="zip"
               label="Zip"
               rules={[{ validator: commonFn.zipValidator }]}
             >
               <Input placeholder="Zip" />
             </Form.Item>
                <Form.Item name="fedId" label="Federal Tax ID">
                  <Input />
                </Form.Item>
                <Form.Item name="stateId" label="State Tax ID">
                  <Input />
                </Form.Item>
                <Form.Item name="phone" label="Phone">
                  <Input />
                </Form.Item>
              </div>

            </Flex>
               </Form>
               </div>
          </div>
          
        </Flex>
   
    </Modal>
  );
});

export default AddModal;
